export default __webpack_public_path__ + "static/media/bkg--design-1.72d0c916.jpg";